const DEFAULT_API_URL = "https://aegisapi.edumitram.com:443";
const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

export const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL?.trim();

  if (envUrl) {
    return trimTrailingSlash(envUrl);
  }

  return DEFAULT_API_URL;
};
